export default "__VITE_ASSET__Bl$PfX39__"